import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useUserStore = create(
  persist(
    (set) => ({
      avatar: "/default-avatar.png",
      setAvatar: (url) => set({ avatar: url }),
      name:"demo",
      setName:(name)=>set({name:name}),
      role:"User",
      setRole:(role)=>set({role:role})
    }),
    {
      name: "user-storage",
    }
  )
);